import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModuleListModel } from '../models/ModuleListModel';
import { RuleModel } from '../models/RuleModel';
import { RuleListModel } from '../models/RuleListModel';
import { ModelResponse } from '../../core/services/ModelResponse';
import { RuleParameterModel } from '../models/RuleParameterModel';
import { ParameterModel } from "../models/ParameterModel";
import { UpdateParametersModel } from "../models/UpdateParametersModel";

@Injectable()
export class ParameterService {

  constructor(public httpClient: HttpClient) {}

  getParameters(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<ModelResponse<UpdateParametersModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<ModelResponse<UpdateParametersModel>>("/api/BusinessRule/Parameter/ListQuery", { params: params });
  }

  removeParameter(key: string): Observable<ModelResponse<ParameterModel>> {
    return this.httpClient.delete<ModelResponse<ParameterModel>>(`/api/BusinessRule/Parameter/Delete/${key}`);
  }

  addParameter(key: string, model: ParameterModel): Observable<ModelResponse<ParameterModel>> {
    return this.httpClient.put<ModelResponse<ParameterModel>>(`/api/BusinessRule/Parameter/`, model);
  }

  //updateGlobalParameter(parameter: ParameterModel) {
  //  return this.httpClient.post<ModelResponse<boolean>>("/api/BusinessRule/UpdateGlobalParameter/", { parameter: parameter });
  //}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/services/ParameterService.ts